"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdatePriorityTask = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const update_priority_task_mutation_1 = require("../update-priority-task.mutation");
const useUpdatePriorityTask = () => {
    const [updatePriorityTaskMutation, { loading, error }] = (0, react_2.useMutation)(update_priority_task_mutation_1.UPDATE_PRIORITY_TASK);
    const updatePriorityTask = (0, react_1.useCallback)((input, options) => updatePriorityTaskMutation(Object.assign({ variables: { input } }, options)), [updatePriorityTaskMutation]);
    return {
        updatePriorityTask,
        loading,
        error,
    };
};
exports.useUpdatePriorityTask = useUpdatePriorityTask;
